import * as $runtime from "../runtime.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as DOM$dHTML$dIndexed$dInputType from "../DOM.HTML.Indexed.InputType/index.js";
import * as DOM$dHTML$dIndexed$dStepValue from "../DOM.HTML.Indexed.StepValue/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML$dEvents from "../Halogen.HTML.Events/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as Util$dArray from "../Util.Array/index.js";
import * as Util$dHalogen from "../Util.Halogen/index.js";
import * as Web$dEvent$dEvent from "../Web.Event.Event/index.js";
import * as Web$dHTML$dEvent$dDataTransfer from "../Web.HTML.Event.DataTransfer/index.js";
import * as Web$dHTML$dEvent$dDragEvent from "../Web.HTML.Event.DragEvent/index.js";
import * as Web$dHTML$dHTMLInputElement from "../Web.HTML.HTMLInputElement/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
const $Action = (tag, _1, _2) => ({tag, _1, _2});
const type_ = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("type");
  return x => $0(DOM$dHTML$dIndexed$dInputType.renderInputType(x));
})();
const value = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("value");
const monadEffectHalogenM = /* #__PURE__ */ Halogen$dQuery$dHalogenM.monadEffectHalogenM(Effect$dAff.monadEffectAff);
const generateId = /* #__PURE__ */ (() => monadEffectHalogenM.liftEffect(Data$dUUID.getUUIDImpl))();
const $$get = /* #__PURE__ */ Control$dMonad$dFree.$Free(
  /* #__PURE__ */ Control$dMonad$dFree.$FreeView(
    "Bind",
    /* #__PURE__ */ Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s, s)),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const foldMap1 = /* #__PURE__ */ (() => {
  const mempty = Control$dMonad$dFree.monoidFree(Data$dMonoid.monoidUnit).mempty;
  return v => v1 => {
    if (v1.tag === "Nothing") { return mempty; }
    if (v1.tag === "Just") { return v(v1._1); }
    $runtime.fail();
  };
})();
const clamp = low => hi => x => {
  const v = Data$dOrd.ordInt.compare(low)(x);
  const $0 = (() => {
    if (v === "LT") { return x; }
    if (v === "EQ") { return low; }
    if (v === "GT") { return low; }
    $runtime.fail();
  })();
  const v$1 = Data$dOrd.ordInt.compare(hi)($0);
  if (v$1 === "LT") { return hi; }
  if (v$1 === "EQ") { return hi; }
  if (v$1 === "GT") { return $0; }
  $runtime.fail();
};
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v === "LT") { return x; }
  if (v === "EQ") { return x; }
  if (v === "GT") { return y; }
  $runtime.fail();
};
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const Receive = value0 => $Action("Receive", value0);
const AddCard = /* #__PURE__ */ $Action("AddCard");
const RemoveCard = value0 => $Action("RemoveCard", value0);
const UpdateCard = value0 => $Action("UpdateCard", value0);
const UpdateTotal = value0 => $Action("UpdateTotal", value0);
const UpdateHand = value0 => $Action("UpdateHand", value0);
const UpdateOthers = value0 => $Action("UpdateOthers", value0);
const SelectOnFocus = value0 => $Action("SelectOnFocus", value0);
const StartReorder = value0 => value1 => $Action("StartReorder", value0, value1);
const HandleDragBehavior = value0 => $Action("HandleDragBehavior", value0);
const ExecuteReorder = value0 => value1 => $Action("ExecuteReorder", value0, value1);
const component = /* #__PURE__ */ (() => {
  const styleFormInput = Data$dString$dCommon.joinWith(" ")([
    "appearance-none rounded-none border-b border-transparent bg-white p-1 text-gray-700",
    "transition-colors duration-75 hover:border-gray-500 focus:border-slate-800 focus:outline-none"
  ]);
  const styleFormNumber = Data$dString$dCommon.joinWith(" ")(["w-16 text-right", styleFormInput]);
  const renderIntegerInput = (id, text, count, min1, max, handler) => Halogen$dVDom$dTypes.$VDom(
    "Elem",
    Data$dMaybe.Nothing,
    "div",
    [Halogen$dHTML$dProperties.class_("mx-1 flex flex-wrap justify-end border-b border-gray-500")],
    [
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "label",
        [Halogen$dHTML$dProperties.class_("p-1"), Halogen$dHTML$dProperties.for(id)],
        [Halogen$dVDom$dTypes.$VDom("Text", text)]
      ),
      Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "input",
        [
          Halogen$dHTML$dProperties.class_(styleFormNumber),
          type_(DOM$dHTML$dIndexed$dInputType.InputNumber),
          Halogen$dHTML$dProperties.id(id),
          value(Data$dShow.showIntImpl(count)),
          Halogen$dHTML$dProperties.step(DOM$dHTML$dIndexed$dStepValue.$StepValue("Step", 1.0)),
          Halogen$dHTML$dProperties.min(Data$dInt.toNumber(min1)),
          Halogen$dHTML$dProperties.max(Data$dInt.toNumber(max)),
          Halogen$dVDom$dDOM$dProp.$Prop("Handler", "focus", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $Action("SelectOnFocus", ev)))),
          Halogen$dHTML$dEvents.addForeignPropHandler("change")("value")(Foreign.readString(Data$dIdentity.monadIdentity))(x => handler((() => {
            const $0 = Data$dInt.fromString(x);
            if ($0.tag === "Nothing") { return 0; }
            if ($0.tag === "Just") { return $0._1; }
            $runtime.fail();
          })()))
        ],
        []
      )
    ]
  );
  const countCards = Data$dFoldable.foldableArray.foldMap((() => {
    const semigroupAdditive1 = {append: v => v1 => v + v1 | 0};
    return {mempty: 0, Semigroup0: () => semigroupAdditive1};
  })())(v => v.count);
  return {
    initialState: x => x,
    render: v => {
      const $0 = v.others;
      const cardCount = countCards(v.cards);
      return Halogen$dVDom$dTypes.$VDom(
        "Elem",
        Data$dMaybe.Nothing,
        "div",
        [Halogen$dHTML$dProperties.class_("rounded border-2 border-amber-500 p-1")],
        [
          (() => {
            const $1 = cardCount + $0 | 0;
            return Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "div",
              [Halogen$dHTML$dProperties.class_("flex gap-1")],
              [
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "div",
                  [Halogen$dHTML$dProperties.class_("mx-1 flex grow flex-wrap text-sky-900")],
                  [
                    Util$dHalogen.fa("fa-layer-group")(["m-1 text-2xl"]),
                    Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "div", [Halogen$dHTML$dProperties.class_("m-1")], [Halogen$dVDom$dTypes.$VDom("Text", "デッキ情報")])
                  ]
                ),
                renderIntegerInput("hand", "手札枚数:", v.hand, 1, $1, UpdateHand),
                renderIntegerInput("deck", "デッキ枚数:", $1, cardCount, 255, UpdateTotal)
              ]
            );
          })(),
          Halogen$dVDom$dTypes.$VDom(
            "Keyed",
            Data$dMaybe.Nothing,
            "ul",
            [
              Halogen$dHTML$dProperties.class_("m-1"),
              Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragenter", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $Action("HandleDragBehavior", ev)))),
              Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragover", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $Action("HandleDragBehavior", ev))))
            ],
            Data$dFunctor.arrayMap(card => {
              const $1 = card.id;
              return Data$dTuple.$Tuple(
                $1,
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "li",
                  [
                    Halogen$dHTML$dProperties.class_("flex"),
                    Halogen$dVDom$dDOM$dProp.$Prop(
                      "Ref",
                      x => Data$dMaybe.$Maybe(
                        "Just",
                        Halogen$dQuery$dInput.$Input(
                          "RefUpdate",
                          $1,
                          (() => {
                            if (x.tag === "Created") { return Data$dMaybe.$Maybe("Just", x._1); }
                            if (x.tag === "Removed") { return Data$dMaybe.Nothing; }
                            $runtime.fail();
                          })()
                        )
                      )
                    ),
                    (() => {
                      const $2 = ExecuteReorder(card.id);
                      return Halogen$dVDom$dDOM$dProp.$Prop("Handler", "drop", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $2(ev))));
                    })()
                  ],
                  [
                    Halogen$dVDom$dTypes.$VDom(
                      "Elem",
                      Data$dMaybe.Nothing,
                      "div",
                      [Halogen$dHTML$dProperties.class_("mx-1 flex items-center")],
                      [
                        Halogen$dVDom$dTypes.$VDom(
                          "Elem",
                          Data$dMaybe.Nothing,
                          "div",
                          [
                            Halogen$dHTML$dProperties.class_("hidden cursor-grab px-1 text-gray-500 active:cursor-grabbing md:block"),
                            Halogen$dHTML$dProperties.draggable(true),
                            (() => {
                              const $2 = StartReorder(card.id);
                              return Halogen$dVDom$dDOM$dProp.$Prop("Handler", "dragstart", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $2(ev))));
                            })()
                          ],
                          [Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-grip-vertical")], [])]
                        ),
                        Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-xmark")], []))("text-gray-500 hover:bg-gray-200")($Action(
                          "RemoveCard",
                          card
                        ))
                      ]
                    ),
                    Halogen$dVDom$dTypes.$VDom(
                      "Elem",
                      Data$dMaybe.Nothing,
                      "div",
                      [Halogen$dHTML$dProperties.class_("flex grow border-b border-gray-500")],
                      [
                        Halogen$dVDom$dTypes.$VDom(
                          "Elem",
                          Data$dMaybe.Nothing,
                          "input",
                          [
                            Halogen$dHTML$dProperties.classes(["grow", styleFormInput]),
                            type_(DOM$dHTML$dIndexed$dInputType.InputText),
                            Halogen$dHTML$dProperties.id("card-" + $1),
                            value(card.name),
                            Halogen$dHTML$dEvents.addForeignPropHandler("change")("value")(Foreign.readString(Data$dIdentity.monadIdentity))(x => $Action(
                              "UpdateCard",
                              {...card, name: x}
                            ))
                          ],
                          []
                        ),
                        Halogen$dVDom$dTypes.$VDom(
                          "Elem",
                          Data$dMaybe.Nothing,
                          "input",
                          [
                            Halogen$dHTML$dProperties.class_(styleFormNumber),
                            type_(DOM$dHTML$dIndexed$dInputType.InputNumber),
                            Halogen$dHTML$dProperties.id("count-" + $1),
                            Halogen$dHTML$dProperties.step(DOM$dHTML$dIndexed$dStepValue.$StepValue("Step", 1.0)),
                            value(Data$dShow.showIntImpl(card.count)),
                            Halogen$dHTML$dProperties.min(0.0),
                            Halogen$dHTML$dProperties.max(card.name === "" ? 0.0 : Data$dInt.toNumber(card.count + $0 | 0)),
                            Halogen$dVDom$dDOM$dProp.$Prop(
                              "Handler",
                              "focus",
                              ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $Action("SelectOnFocus", ev)))
                            ),
                            Halogen$dHTML$dEvents.addForeignPropHandler("change")("value")(Foreign.readString(Data$dIdentity.monadIdentity))(x => $Action(
                              "UpdateCard",
                              (() => {
                                const $2 = Data$dInt.fromString(x);
                                return {
                                  ...card,
                                  count: (() => {
                                    if ($2.tag === "Nothing") { return 0; }
                                    if ($2.tag === "Just") { return $2._1; }
                                    $runtime.fail();
                                  })()
                                };
                              })()
                            ))
                          ],
                          []
                        )
                      ]
                    )
                  ]
                )
              );
            })(v.cards)
          ),
          Halogen$dVDom$dTypes.$VDom(
            "Elem",
            Data$dMaybe.Nothing,
            "div",
            [Halogen$dHTML$dProperties.class_("flex gap-1")],
            [
              Halogen$dVDom$dTypes.$VDom(
                "Elem",
                Data$dMaybe.Nothing,
                "div",
                [Halogen$dHTML$dProperties.class_("mx-1 grow")],
                [
                  Util$dHalogen.button(Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "i", [Halogen$dHTML$dProperties.class_("fa-solid fa-plus")], []))("border border-sky-500 text-sky-700 hover:bg-sky-200")(AddCard)
                ]
              ),
              renderIntegerInput("others", "その他のカード:", $0, 0, 255 - cardCount | 0, UpdateOthers)
            ]
          )
        ]
      );
    },
    eval: Halogen$dComponent.mkEval({
      ...Halogen$dComponent.defaultEval,
      handleAction: v => {
        if (v.tag === "Receive") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.CatNil
          );
        }
        if (v.tag === "AddCard") {
          return Control$dMonad$dFree.$Free(
            generateId._1,
            (() => {
              if (generateId._2.tag === "CatNil") {
                return Data$dCatList.$CatList(
                  "CatCons",
                  id => Control$dMonad$dFree.$Free(
                    $$get._1,
                    Data$dCatList.$CatList(
                      "CatCons",
                      deck => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", {...deck, cards: Data$dArray.snoc(deck.cards)({id, name: "", count: 0})}, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  ),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                );
              }
              if (generateId._2.tag === "CatCons") {
                return Data$dCatList.$CatList(
                  "CatCons",
                  generateId._2._1,
                  Data$dCatQueue.$CatQueue(
                    generateId._2._2._1,
                    Data$dList$dTypes.$List(
                      "Cons",
                      Data$dCatList.$CatList(
                        "CatCons",
                        id => Control$dMonad$dFree.$Free(
                          $$get._1,
                          Data$dCatList.$CatList(
                            "CatCons",
                            deck => Control$dMonad$dFree.$Free(
                              Control$dMonad$dFree.$FreeView(
                                "Bind",
                                Halogen$dQuery$dHalogenM.$HalogenF("Raise", {...deck, cards: Data$dArray.snoc(deck.cards)({id, name: "", count: 0})}, undefined),
                                x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                              ),
                              Data$dCatList.CatNil
                            ),
                            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                          )
                        ),
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      ),
                      generateId._2._2._2
                    )
                  )
                );
              }
              $runtime.fail();
            })()
          );
        }
        if (v.tag === "RemoveCard") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              deck => Control$dMonad$dFree.$Free(
                Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF(
                    "Raise",
                    {...deck, cards: Data$dArray.deleteBy(x => y => x.id === y.id)($0)(deck.cards), others: deck.others + $0.count | 0},
                    undefined
                  ),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                ),
                Data$dCatList.CatNil
              ),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "UpdateCard") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              deck => foldMap1(Halogen$dQuery$dHalogenM.raise)((() => {
                const $1 = $0.id;
                const $2 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, x => x.id === $1, deck.cards);
                if ($2.tag === "Just") {
                  if ($2._1 >= 0 && $2._1 < deck.cards.length) {
                    const $3 = deck.cards[$2._1];
                    const $$new = {...$0, count: $0.name === "" ? 0 : clamp(0)($3.count + deck.others | 0)($0.count)};
                    const $4 = Data$dArray._updateAt(Data$dMaybe.Just, Data$dMaybe.Nothing, $2._1, $$new, deck.cards);
                    if ($4.tag === "Just") { return Data$dMaybe.$Maybe("Just", {...deck, cards: $4._1, others: deck.others - ($$new.count - $3.count | 0) | 0}); }
                    if ($4.tag === "Nothing") { return Data$dMaybe.Nothing; }
                    $runtime.fail();
                  }
                  return Data$dMaybe.Nothing;
                }
                if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
                $runtime.fail();
              })()),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "UpdateTotal") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              deck => Control$dMonad$dFree.$Free(
                Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF("Raise", {...deck, others: $0 - countCards(deck.cards) | 0}, undefined),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                ),
                Data$dCatList.CatNil
              ),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "UpdateHand") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              deck => Control$dMonad$dFree.$Free(
                Control$dMonad$dFree.$FreeView(
                  "Bind",
                  Halogen$dQuery$dHalogenM.$HalogenF("Raise", {...deck, hand: clamp(1)(countCards(deck.cards) + deck.others | 0)($0)}, undefined),
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                ),
                Data$dCatList.CatNil
              ),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "UpdateOthers") {
          const $0 = v._1;
          return Control$dMonad$dFree.$Free(
            $$get._1,
            Data$dCatList.$CatList(
              "CatCons",
              deck => {
                const cardCount = countCards(deck.cards);
                const deckCount = clamp(cardCount)(255)(cardCount + $0 | 0);
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("Raise", {...deck, others: deckCount - cardCount | 0, hand: min(deck.hand)(deckCount)}, undefined),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              },
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
        }
        if (v.tag === "SelectOnFocus") {
          return monadEffectHalogenM.liftEffect((() => {
            const $0 = Data$dNullable.nullable(Web$dEvent$dEvent._target(v._1), Data$dMaybe.Nothing, Data$dMaybe.Just);
            const $1 = (() => {
              if ($0.tag === "Just") { return Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "HTMLInputElement", $0._1); }
              if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
              $runtime.fail();
            })();
            if ($1.tag === "Nothing") { return () => {}; }
            if ($1.tag === "Just") { return Web$dHTML$dHTMLInputElement.select($1._1); }
            $runtime.fail();
          })());
        }
        if (v.tag === "StartReorder") {
          const $0 = v._1;
          const transfer = Web$dHTML$dEvent$dDragEvent.dataTransfer(v._2);
          const $1 = monadEffectHalogenM.liftEffect(Web$dHTML$dEvent$dDataTransfer._setData("tcg-calculator/card")($0)(transfer));
          const $2 = () => Control$dMonad$dFree.$Free(
            Control$dMonad$dFree.$FreeView(
              "Bind",
              Halogen$dQuery$dHalogenM.$HalogenF("GetRef", $0, Halogen$dQuery$dHalogenM.identity),
              x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
            ),
            Data$dCatList.$CatList(
              "CatCons",
              elem => monadEffectHalogenM.liftEffect((() => {
                if (elem.tag === "Nothing") { return () => {}; }
                if (elem.tag === "Just") { return Web$dHTML$dEvent$dDataTransfer._setDragImage(transfer)(elem._1)(5)(15); }
                $runtime.fail();
              })()),
              Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
            )
          );
          return Control$dMonad$dFree.$Free(
            $1._1,
            (() => {
              if ($1._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $2, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
              if ($1._2.tag === "CatCons") {
                return Data$dCatList.$CatList(
                  "CatCons",
                  $1._2._1,
                  Data$dCatQueue.$CatQueue(
                    $1._2._2._1,
                    Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $2, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $1._2._2._2)
                  )
                );
              }
              $runtime.fail();
            })()
          );
        }
        if (v.tag === "HandleDragBehavior") {
          const transfer = Web$dHTML$dEvent$dDragEvent.dataTransfer(v._1);
          const $0 = monadEffectHalogenM.liftEffect((() => {
            const $0 = Web$dEvent$dEvent.preventDefault(v._1);
            return () => {
              $0();
              return Web$dHTML$dEvent$dDataTransfer.setDropEffect(Web$dHTML$dEvent$dDataTransfer.Move)(transfer)();
            };
          })());
          if (eq1(Web$dHTML$dEvent$dDataTransfer.types(transfer))(["tcg-calculator/card"])) { return $0; }
          return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
        }
        if (v.tag === "ExecuteReorder") {
          const $0 = v._1;
          const $1 = v._2;
          const $2 = monadEffectHalogenM.liftEffect(Web$dHTML$dEvent$dDataTransfer._getData("tcg-calculator/card")(Web$dHTML$dEvent$dDragEvent.dataTransfer($1)));
          const $3 = id => {
            const $3 = id === "";
            const $4 = monadEffectHalogenM.liftEffect(Web$dEvent$dEvent.preventDefault($1));
            const $5 = () => Control$dMonad$dFree.$Free(
              $$get._1,
              Data$dCatList.$CatList(
                "CatCons",
                v1 => foldMap1(Halogen$dQuery$dHalogenM.raise)((() => {
                  if (Data$dUUID.validateV4UUID(id) && id !== $0) {
                    const $5 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, x => x.id === id, v1.cards);
                    if ($5.tag === "Just") {
                      const $6 = Data$dArray.findIndexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, x => x.id === $0, v1.cards);
                      if ($6.tag === "Just") { return Data$dMaybe.$Maybe("Just", {...v1, cards: Util$dArray.shiftInsert($5._1)($6._1)(v1.cards)}); }
                      if ($6.tag === "Nothing") { return Data$dMaybe.Nothing; }
                      $runtime.fail();
                    }
                    if ($5.tag === "Nothing") { return Data$dMaybe.Nothing; }
                    $runtime.fail();
                  }
                  return Data$dMaybe.Nothing;
                })()),
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              )
            );
            const $6 = Control$dMonad$dFree.$Free(
              $4._1,
              (() => {
                if ($4._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
                if ($4._2.tag === "CatCons") {
                  return Data$dCatList.$CatList(
                    "CatCons",
                    $4._2._1,
                    Data$dCatQueue.$CatQueue(
                      $4._2._2._1,
                      Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $5, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $4._2._2._2)
                    )
                  );
                }
                $runtime.fail();
              })()
            );
            if (!$3) { return $6; }
            if ($3) { return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil); }
            $runtime.fail();
          };
          return Control$dMonad$dFree.$Free(
            $2._1,
            (() => {
              if ($2._2.tag === "CatNil") { return Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)); }
              if ($2._2.tag === "CatCons") {
                return Data$dCatList.$CatList(
                  "CatCons",
                  $2._2._1,
                  Data$dCatQueue.$CatQueue(
                    $2._2._2._1,
                    Data$dList$dTypes.$List("Cons", Data$dCatList.$CatList("CatCons", $3, Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)), $2._2._2._2)
                  )
                );
              }
              $runtime.fail();
            })()
          );
        }
        $runtime.fail();
      },
      receive: x => Data$dMaybe.$Maybe("Just", $Action("Receive", x))
    })
  };
})();
export {
  $Action,
  AddCard,
  ExecuteReorder,
  HandleDragBehavior,
  Receive,
  RemoveCard,
  SelectOnFocus,
  StartReorder,
  UpdateCard,
  UpdateHand,
  UpdateOthers,
  UpdateTotal,
  clamp,
  component,
  eq1,
  foldMap1,
  generateId,
  $$get as get,
  min,
  monadEffectHalogenM,
  type_,
  value
};
